<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <customer-form></customer-form>
    </div>
</template>
<script>
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import Form from './components/Form'

  export default {
    name: 'NewCustomer',
    components: { Breadcrumb, CustomerForm: Form },
    data () {
      return {
        onlyNumber: /[\D]/g,
        changeAddress: false,
        createByContract: false,
        isBusiness: false,
        lockBusiness: false,
        cepFound: false,
        id: null,
        name: '',
        email: '',
        kind: 'P',
        cpf: '',
        cnpj: '',
        tradeName: '',
        companyName: '',
        contactId: null,
        fullPhone: '',
        addressId: null,
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        phoneMask: '(99) 9999-9999',
        parsedCust: {},
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('customers.new.new_customer'),
          'paths': {
            0: {
              'title': this.$t('customers.main.title'),
              'path': '/customers/new'
            }
          }
        }
      }
    },
    mounted () {
      if (this.$route.params !== undefined) {
        this.createByContract = this.$route.params.createByContract
      }
    }
  }
</script>



// WEBPACK FOOTER //
// New.vue?09c6e1f0